// import React from 'react';
// import Link from 'next/link';
// import Image from 'next/image';
// import Button from '../button';
// import Card from '../card';
// import Calendar from 'react-calendar';
// import Input from '../input';
// import { closeModal } from '../../../assets/icons';
// import moment from 'moment';
import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Button from '../button';
import Card from '../card';
import Calendar from 'react-calendar';
import Input from '../input';
import { closeModal } from '../../../assets/icons';
import moment from 'moment';

const CalendarModal = ({
  closeCalendar,
  date,
  setDate,
  selectRange,
  handleApply,
}) => {
  const [inputDate, setInputDate] = useState({
    from: moment(date[0]).format('YYYY-MM-DD'),
    to: selectRange ? moment(date[1]).format('YYYY-MM-DD') : '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputDate((prev) => ({ ...prev, [name]: value }));

    const newDate = new Date(value);
    if (name === 'from') {
      setDate((prev) => [newDate, prev[1]]);
    } else if (name === 'to') {
      setDate((prev) => [prev[0], newDate]);
    }
  };

  return (
    <div className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40">
      <Card className="rounded-xl md:rounded-none w-11/12 lg:w-8/12 xl:w-3/5 h-auto">
        <div className="mb-10 flex justify-end">
          <button className="outline-none" onClick={() => closeCalendar(true)}>
            <Image src={closeModal} height={20} width={20} alt="close modal" />
          </button>
        </div>
        <h2 className="text-zinc-900 text-[20px] font-semibold">
          Customised date range
        </h2>
        <div className="flex justify-around flex-wrap-reverse mt-8">
          <div className="w-full md:w-5/12 lg:w-4/12">
            <div className="flex justify-between items-center">
              <p className="text-base font-medium w-2/12"> From </p>
              <div className="w-9/12">
                <Input
                  type="date"
                  name="from"
                  value={inputDate.from}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {selectRange && (
              <div className="flex justify-between items-center">
                <p className="text-base font-medium w-2/12"> To </p>
                <div className="w-9/12">
                  <Input
                    type="date"
                    name="to"
                    value={inputDate.to}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            )}
            <div className="mt-5 flex justify-between items-center">
              <div className="w-2/12"></div>
              <div className="w-9/12">
                <div className="w-28">
                  <Link href="#" passHref>
                    <Button
                      type="button"
                      label="Apply"
                      className="btn btn-primary py-2 px-4"
                      onClick={handleApply}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-5/12 mb-5 lg:mb-0 shadow lg:w-7/12 rounded-xl">
            <div className="flex flex-row justify-center shadow">
              <Calendar
                onChange={setDate}
                value={date}
                selectRange={selectRange}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CalendarModal;

// const CalendarModal = ({
//   closeCalendar,
//   date,
//   setDate,
//   selectRange,
//   handleApply,
// }) => {
//   return (
//     <div className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40">
//       <Card className="rounded-xl md:rounded-none w-11/12 lg:w-8/12 xl:w-3/5 h-auto">
//         <div className="mb-10 flex justify-end">
//           <button className="outline-none" onClick={() => closeCalendar(true)}>
//             <Image src={closeModal} height={20} width={20} alt="close modal" />
//           </button>
//         </div>
//         <h2 className="text-zinc-900 text-[20px] font-semibold">
//           Customised date range
//         </h2>
//         <div className="flex justify-around flex-wrap-reverse mt-8">
//           <div className="w-full md:w-5/12 lg:w-4/12">
//             <div className="flex justify-between items-center">
//               <p className="text-base font-medium w-2/12"> From </p>
//               <div className="w-9/12">
//                 <Input
//                   placeholder={moment(date[0]?.toDateString()).format(
//                     'DD/MM/YYYY'
//                   )}
                  
//                 />
//               </div>
//             </div>
//             {selectRange && (
//               <div className="flex justify-between items-center">
//                 <p className="text-base font-medium w-2/12"> To </p>
//                 <div className="w-9/12">
//                   <Input
//                     placeholder={moment(date[1]?.toDateString()).format(
//                       'DD/MM/YYYY'
//                     )}
               
//                   />
//                 </div>
//               </div>
//             )}
//             <div className="mt-5 flex justify-between items-center">
//               <div className="w-2/12"></div>
//               <div className="w-9/12">
//                 <div className="w-28">
//                   <Link href="#" passHref>
//                     <Button
//                       type="button"
//                       label="Apply"
//                       className="btn btn-primary py-2 px-4"
//                       onClick={handleApply}
//                     />
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="w-full md:w-5/12 mb-5 lg:mb-0 shadow lg:w-7/12 rounded-xl">
//             <div className="flex flex-row justify-center shadow">
//               <Calendar
//                 onChange={setDate}
//                 defaultValue={date}
//                 selectRange={selectRange}
//               />
//             </div>
//           </div>
//         </div>
//       </Card>
//     </div>
//   );
// };

// export default CalendarModal;
